import React, { useState } from "react";
import { Modal, ModalBody, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { deleteCategory } from "../../../redux/slices/categorySlice";
import { deleteLocation } from "../../../redux/slices/locationSlice";
import {
  deleteRental,
  deleteRentalDimension,
} from "../../../redux/slices/rentalSlice";
import { deleteTrainer } from "../../../redux/slices/trainerSlice";
import { deleteService } from "../../../redux/slices/serviceSlice";
import { deleteDiscountPackage } from "../../../redux/slices/discountPackageSlice";
import { deleteSubAdmin } from "../../../redux/slices/subAdminSlice";
import { deleteGift } from "../../../redux/slices/giftSlice";
import { deleteChats } from "../../../redux/slices/chatSlice";
import { deleteArea } from "../../../redux/slices/areaSlice";
import { removeVoucher } from "../../../redux/slices/voucherSlice";
import { deletePayment } from "../../../redux/slices/paymentSlice";
import { deleteInquiry } from "../../../redux/slices/querySlice";
import { deleteBirthday } from "../../../redux/slices/birthdaySlice";

const DeleteModal = ({
  forCategory = false,
  forLocation = false,
  forRental = false,
  forDimension = false,
  forTrainer = false,
  forService = false,
  forDiscountPackage = false,
  forSubAdmin = false,
  forChat = false,
  forGift = false,
  forArea = false,
  forVoucher = false,
  forPayment = false,
  forInquiry = false,
  forBirthday = false,
  deleteId,
  id,
  deleteModal,
  setDeleteModal,
}) => {
  const dispatch = useDispatch();
  const [loading, setIsLoading] = useState(false);

  const handleDelete = () => {
    setIsLoading(true);
    if (forCategory) {
      dispatch(deleteCategory(deleteId, setIsLoading, setDeleteModal));
    }
    if (forLocation) {
      dispatch(deleteLocation(deleteId, setIsLoading, setDeleteModal));
    }
    if (forRental) {
      dispatch(deleteRental(deleteId, setIsLoading, setDeleteModal));
    }
    if (forDimension) {
      dispatch(
        deleteRentalDimension(deleteId, id, setIsLoading, setDeleteModal)
      );
    }
    if (forTrainer) {
      dispatch(deleteTrainer(deleteId, setIsLoading, setDeleteModal));
    }
    if (forService) {
      dispatch(deleteService(deleteId, setIsLoading, setDeleteModal));
    }
    if (forDiscountPackage) {
      dispatch(deleteDiscountPackage(deleteId, setIsLoading, setDeleteModal));
    }
    if (forSubAdmin) {
      dispatch(deleteSubAdmin(deleteId, setIsLoading, setDeleteModal));
    }
    if (forGift) {
      dispatch(deleteGift(deleteId, setIsLoading, setDeleteModal));
    }
    if (forChat) {
      dispatch(deleteChats(deleteId, setIsLoading, setDeleteModal));
    }
    if (forArea) {
      dispatch(deleteArea(deleteId, setIsLoading, setDeleteModal));
    }
    if (forVoucher) {
      dispatch(removeVoucher(deleteId, setIsLoading, setDeleteModal));
    }
    if (forPayment) {
      dispatch(deletePayment(deleteId, setIsLoading, setDeleteModal));
    }
    if (forInquiry) {
      dispatch(deleteInquiry(deleteId, setIsLoading, setDeleteModal));
    }
    if (forBirthday) {
      dispatch(deleteBirthday(deleteId, setIsLoading, setDeleteModal));
    }
  };

  return (
    <Modal
      show={deleteModal}
      size="sx"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <ModalBody>
        <h5 className="mb-3">Are you sure want to Delete ?</h5>
      </ModalBody>
      <Modal.Footer>
        {loading ? (
          <div className="w-100 d-flex">
            <div
              class="spinner-border text-primary mx-auto"
              role="status"
            ></div>
          </div>
        ) : (
          <>
            <button
              type="button"
              className="btn_secondary"
              onClick={() => setDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn_primary"
              onClick={handleDelete}
            >
              Delete
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
